import ArchiveActionModel from "../models/ArchiveActionModel";
import webServiceWrapper from "./webServiceWrapper";

const ADD_ARCHIVE_ROUTE = "/archive/AddArchive";

const AddArchive = (number, data, userGuid, secondaryId, createdBy) => {
  const archive = new ArchiveActionModel(
    number,
    data,
    userGuid,
    secondaryId,
    createdBy
  );
  return webServiceWrapper.post(ADD_ARCHIVE_ROUTE, archive);
};

const AddPageViewedArchive = (userGUID, videoName) => {
  const archive = new ArchiveActionModel(
    1000,
    `User viewed video content page with videoName as: ${videoName}`,
    userGUID,
    0,
    userGUID
  );
  return webServiceWrapper.post(ADD_ARCHIVE_ROUTE, archive);
};

const AddVideoPlayedArchive = (userGUID, secondaryId) => {
  const archive = new ArchiveActionModel(
    1001,
    "User started playing video",
    userGUID,
    secondaryId,
    userGUID
  );
  return webServiceWrapper.post(ADD_ARCHIVE_ROUTE, archive);
};

export const archiveActionService = {
  AddArchive,
  AddPageViewedArchive,
  AddVideoPlayedArchive,
};
